function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { Field } from "react-final-form";
import MaterialTextField from "@mui/material/TextField";
var NumberField = function(_param) {
    var name = _param.name, validate = _param.validate, props = _object_without_properties(_param, [
        "name",
        "validate"
    ]);
    var handleWheelEvent = function(e) {
        var targetElement = e.target;
        targetElement.blur();
    };
    return /*#__PURE__*/ _jsx(Field, {
        name: name,
        type: "number",
        validate: validate,
        parse: function(value) {
            return Number.isNaN(Number(value)) ? 0 : Number(value);
        },
        render: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ _jsx(MaterialTextField, _object_spread({
                color: "primary",
                type: "number",
                error: !!(meta.touched && meta.error),
                helperText: meta.touched && meta.error ? meta.error : "",
                onWheel: handleWheelEvent,
                css: {
                    "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
                        //chrome, safari, edge, opera
                        "-webkit-appearance": "none",
                        margin: 0
                    },
                    "input[type=number]": {
                        //firefox
                        "-moz-appearance": "textfield"
                    }
                },
                id: name
            }, props, input));
        }
    });
};
export default NumberField;
